import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-NoImage",
  "use": "svg-icon-NoImage-usage",
  "viewBox": "0 0 41 32",
  "content": "<symbol viewBox=\"0 0 41 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-NoImage\"><path d=\"M16 12c0-2.208-1.792-4-4-4s-4 1.792-4 4 1.792 4 4 4 4-1.792 4-4m20 15v-3l-10.5-9L11 27z\" /><path d=\"M41 32V0H0v32h36v-5H5V5h31v27z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol